// componenets
import {
  Hero,
  Staking,
  ExclusiveNFTS,
  Features,
  Gameplay,
  HowItWork,
  Mission,
  Vision,
  Faqs,
  Benefit,
  Tokenomics,
  Roadmap,
  Friends,
  GoingLive,
  Protected,
} from "../components/elements";

function Home() {
  return (
    <>
      <Hero />
      <Staking />
      <ExclusiveNFTS />
      <Features />
      <Gameplay />
      <HowItWork />
      <Benefit />
      <GoingLive />
      <Mission />
      <Vision />
      <Tokenomics />
      <Roadmap />
      <Protected />
      <Faqs />
      <Friends />
    </>
  );
}
export default Home;
